<template>
  <v-container>
    <v-form ref="form">
    <v-row>
      <v-col cols="12">
        <h2>Formulario de Facturación</h2>
      </v-col>
    </v-row>
    <!-- Selección de Receptor -->
    <v-row>
      <v-col cols="12" md="6">
        <ReceptorAutocomplete @select="onReceptorSelect" />
      </v-col>

      <v-col cols="3">
        <p><strong>RFC:</strong> {{ receptorSeleccionado?.RFC ?? '' }}</p>

      </v-col>
      <v-col cols="3" >
      <v-text-field
          v-model="claveSAT"
          label="Clave SAT"
          outlined dense
          readonly 
        ></v-text-field>
      </v-col>
    </v-row>

    <!-- Selección de Uso CFDI -->
    <v-row>
      <v-col cols="12" md="6" v-if="receptorSeleccionado">
        <UsoCFDISelect
          :tipo-persona="receptorSeleccionado.Tipo"
          @select="usoSeleccionado = $event"
        />
      </v-col>
    </v-row>



    <!-- Subtotal, IVA, Total -->
     
<v-row justify="center">
      <v-col cols="12" md="4">
        <!-- Subtotal -->

        <v-row class="align-center">
          <v-col cols="5" class="text-right font-weight-bold">
            Subtotal
          </v-col>
          <v-col cols="7">
            <v-text-field
          :value="formattedSubtotal"
          readonly
          outlined dense
            ></v-text-field>
          </v-col>
        </v-row>

        <!-- IVA -->
        <v-row class="align-center">
        <v-col cols="5" class="text-right font-weight-bold">
            IVA (16%)
          </v-col>
          <v-col cols="7">
            <v-text-field
          :value="formattedIva"
          readonly
          outlined dense
            ></v-text-field>
          </v-col>

        </v-row>

        <!-- Línea de separación -->
        <div class="total-divider"></div>

        <!-- Total -->
        <v-row class="align-center">
         <v-col cols="5" class="text-right font-weight-bold">
            Total
          </v-col>
          <v-col cols="7">
            <v-text-field
          ref="totalInput"
          outlined dense clearable
            ></v-text-field>
          </v-col>

        </v-row>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="6" >
        <v-textarea
          v-model="descripcionAmpliada"
          label="Descripción"
          outlined dense
          rows="5"
        ></v-textarea>
      </v-col>
    </v-row>
    <v-row class="mt-4">
    <v-col cols="12">
        <v-btn color="primary" @click="enviarFactura">Generar Factura</v-btn>
    </v-col>
    </v-row>
    </v-form>
  </v-container>
</template>

<script>
import ReceptorAutocomplete from '@/components/selectReceptorFiscal.vue';
import UsoCFDISelect from '@/components/selectReceptorUsoCFDI.vue';

//import Cleave from 'cleave.js';

export default {
  components: { ReceptorAutocomplete, UsoCFDISelect },
  data() {
    return {
      receptorSeleccionado: null,
      usoSeleccionado: null,
      subtotal: 0,
      iva: 0,
      total: 0,
      tasaIVA: 0.16,
      cleaveInstance: null,
      claveSAT: '85101706',
      descripcionAmpliada: ''
    };
  },
  computed: {
    formattedSubtotal() {
      return this.subtotal.toLocaleString('es-MX', { style: 'currency', currency: 'MXN' });
    },
    formattedIva() {
      return this.iva.toLocaleString('es-MX', { style: 'currency', currency: 'MXN' });
    }
  },
  methods: {
    onReceptorSelect(receptor) {
      this.receptorSeleccionado = receptor;
      this.usoSeleccionado = null;
      this.subtotal = 0;
      this.iva = 0;
      this.total = 0;

      // Limpiar campo total
      if (this.cleaveInstance) this.cleaveInstance.setRawValue('');
    },
    setupCleave() {
      const input = this.$refs.totalInput.$el.querySelector('input');
     /* this.cleaveInstance = new Cleave(input, {
        numeral: true,
        numeralThousandsGroupStyle: 'thousand',
        prefix: '$ ',
        rawValueTrimPrefix: true
      });*/

      input.addEventListener('input', () => {
        const raw = parseFloat(this.cleaveInstance.getRawValue()) || 0;
        this.total = raw;
        // Calcular subtotal e IVA automáticamente
        this.subtotal = (raw / (1 + this.tasaIVA)).toFixed(2);
        this.iva = (raw - this.subtotal).toFixed(2);
      });
    },
        enviarFactura() {

      const form = this.$refs.form;
      if (!form.validate()) {
        this.errorMsg = 'Por favor completa todos los campos requeridos.';
        return;
      }

      // Aquí tu lógica de envío
      const datosFactura = {
        receptor: this.selectedRFC,
        usoCFDI: this.usoSeleccionado,
        total: this.total,
      };

      // Ejemplo de envío a API
      this.$http.post('/api/facturas', datosFactura)
        .then(() => {
          this.errorMsg = ''; // limpiar mensaje
          this.$toast.success('Factura enviada correctamente'); // opcional: usar toast
        })
        .catch(() => {
          this.errorMsg = 'Ocurrió un error al enviar la factura.';
        });
    }
  },
  mounted() {
    this.setupCleave();
  }
};
</script>

<style scoped>
.total-divider {
  border-top: 2px solid #000;
  margin: 4px 0 8px 0;
}
</style>
